/**
 * Custom error class for authentication failures
 * Includes a login link for 401 errors
 */
export class AuthenticationError extends Error {
  public readonly isAuthError: boolean = true;
  public readonly loginUrl: string;

  constructor(message?: string) {
    // Include a login link in the error message
    const loginLink = '/login';
    const errorMessage = message || 'Your session has expired. Please log in again.';
    
    super(errorMessage);
    this.name = 'AuthenticationError';
    this.loginUrl = loginLink;
    
    // Maintain proper stack trace for debugging
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthenticationError);
    }
  }

  /**
   * Get the error message with HTML for rendering a login link
   */
  getMessageWithLink(): { message: string; showLoginLink: boolean } {
    return {
      message: this.message,
      showLoginLink: true
    };
  }
}